import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderAbcGospel from "../../../../src/content/abc-gospel-alphabet/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderAbcGospel,
  React
};